<template>
    <div>
        <div class="page-title">Quick Link</div>
        <div class="page-box">
            <div class="page-button"> 
                  <el-button icon="el-icon-plus" @click="onAdd" type="warning"> Add </el-button>
            </div>
            <el-table
                :data="quickLinks"
                style="width: 100%;">
                    <el-table-column
                        prop="title"
                        label="Tittle">
                    </el-table-column>
                    <el-table-column
                        prop="url"
                        label="Url">
                    </el-table-column>
                    <el-table-column
                        label="Action">
                        <template slot-scope="{row}">
                            <el-button type="text" @click="onEdit(row.id)">Edit</el-button>
                            <el-button type="text" @click="onDelete(row.id)">Delete</el-button>
                        </template>
                    </el-table-column>
            </el-table>
        </div>
        <loadingSlotDialog :centerDialogVisible="centerDialogVisible" @close="close">
            <img src="@/assets/images/feather-alert-circle.png"/>
            <div class="dialog-text">Are you sure to delete this item ?</div>
             <el-button @click="onConfirm" type="danger">Confirm</el-button>
             <el-button @click="onCancel">Cancel</el-button>
        </loadingSlotDialog>
        <loadingSlotDialog :centerDialogVisible="addCenterDialogVisible" @close="addClose">
            <div class="dialog-text">Add Quick Link</div>
             <quickLinkFrom :ruleForm="from"></quickLinkFrom>
             <el-button @click="onAddConfirm" type="warning">Confirm</el-button>
             <el-button @click="onAddCancel">Cancel</el-button>
        </loadingSlotDialog>
    </div>
</template>

<script>
    import quickLinkFrom from './components/quickLinkFrom'
    import loadingSlotDialog from '@/components/loadingSlotDialog'
    import {getQuickLinks,addQuickLinks,deleteQuickLinks} from '@/api/admin/notification'
    export default {
        components:{loadingSlotDialog,quickLinkFrom},
        data() {
            return {
                from:{
                    title: "", 
                    url: ""
                },
                centerDialogVisible:false,
                addCenterDialogVisible:false,
                quickLinks: [],
                itemId:0
            }
        },
        created(){
            this.getQuickLinks()
        },
        methods:{
            onConfirm(){
                this.deleteQuickLinks()
            },
            addClose(){
                this.addCenterDialogVisible = false
            },
            close(){
                this.centerDialogVisible = false
            },
            onAddConfirm(){
                this.addQuickLinks()
            },
            onCancel(){
                this.centerDialogVisible = false
            },
            onAddCancel(){
                this.addCenterDialogVisible = false
            },
            onAdd(){
                this.addCenterDialogVisible = true
            },
            onEdit(id){
                  this.$router.push({path:`/admin/quickLink/${id}/edit`})
            },
            onDelete(id){
                this.itemId = id
                this.centerDialogVisible = true
            },
            deleteQuickLinks(){
                deleteQuickLinks(this.itemId).then(()=>{
                    this.getQuickLinks()
                }).finally(()=>{
                     this.centerDialogVisible = false
                })
            },
            addQuickLinks(){
                addQuickLinks(this.from).then(()=>{
                    this.getQuickLinks()
                }).finally(()=>{
                     this.addCenterDialogVisible = false
                })
            },
            getQuickLinks(){
                getQuickLinks().then((v)=>{
                    this.quickLinks = v.data
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.page-box{
    padding-top: 20px;
    background-color: #fff;
    height: 100vh;
}
.page-button{
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
}
.dialog-text{
    font-size: 36px;
    color: #272727;
}
</style>